
export const ERROR_WHITELIST : string[] = [
    "[react-places-autocomplete]: error happened when fetching data from Google Maps API. Please check the docs here", //happens when user adds pin to unknown location
    "Unable to retrieve feature",//Pureconnect first connection failure
    "PureConnect Widget configuration successfully loaded!",//Pureconnect throws error on success startup
    "Error: Real Time Database or Firestore",//user first time login error
    "Warning", //remove warnings that log as error
];
